import api from './api';

// Sprint 29 / Fase 29.C — service do painel pra support flow do player banido.
//
// Endpoints (admin):
//   GET /admin/support-diag?cursor=&limit=&hwid=&session_uuid= → SupportDiagnostic[]
//   GET /admin/support-diag/{uuid}                              → SupportDiagnostic

export interface SupportDiagnostic {
  id: string;
  hwid: string;
  build_id: string;
  sdk_version: string;
  session_uuid: string;
  reported_reason: string;
  log_excerpt: string;
  source_ip: string;
  created_at: string;
}

export interface SupportDiagListParams {
  cursor?: number;
  limit?: number;
  hwid?: string;
  sessionUuid?: string;
}

export async function listSupportDiag(
  params: SupportDiagListParams = {},
): Promise<{ data: SupportDiagnostic[]; count: number }> {
  const resp = await api.get<{ data: SupportDiagnostic[]; count: number }>(
    '/admin/support-diag',
    {
      params: {
        cursor: params.cursor,
        limit: params.limit ?? 50,
        hwid: params.hwid,
        session_uuid: params.sessionUuid,
      },
    },
  );
  return resp.data;
}

export async function getSupportDiag(uuid: string): Promise<SupportDiagnostic> {
  const resp = await api.get<SupportDiagnostic>(`/admin/support-diag/${uuid}`);
  return resp.data;
}
